import { AbstractExternalSyncStorage } from '../AbstractExternalSyncStorage';
export class TableAbstractExternalSyncStorage extends AbstractExternalSyncStorage {
    constructor() {
        super({ rows: [] });
        // rowId -> listeners
        this._rowUpdateListeners = new Map();
        // listeners for any row update
        this._tableUpdateListeners = new Set();
        // rowId -> TableRow
        this._rows = new Map();
        // #region Subscribers
        this.subscribeRowUpdate = (rowId, callback) => {
            let listeners = this._rowUpdateListeners.get(rowId);
            if (!listeners) {
                listeners = [];
                this._rowUpdateListeners.set(rowId, listeners);
            }
            listeners.push(callback);
            return () => {
                const current = this._rowUpdateListeners.get(rowId);
                if (!current) {
                    return;
                }
                const next = current.filter((listener) => listener !== callback);
                if (next.length === 0) {
                    this._rowUpdateListeners.delete(rowId);
                }
                else {
                    this._rowUpdateListeners.set(rowId, next);
                }
            };
        };
        this.subscribeTableUpdate = (callback) => {
            this._tableUpdateListeners.add(callback);
            return () => {
                this._tableUpdateListeners.delete(callback);
            };
        };
    }
    // #endregion Subscribers
    // #region Add/Remove/Update
    getRow(rowId) {
        return this._rows.get(rowId);
    }
    initializeRows(rows) {
        for (const row of rows) {
            this._rows.set(row.id, row);
        }
        this.setSnapshot({ rows: Array.from(this._rows.values()) });
    }
    addRow(row) {
        this._rows.set(row.id, row);
        this.setSnapshot({ rows: Array.from(this._rows.values()) });
    }
    removeRow(row) {
        this._rows.delete(row.id);
        this.setSnapshot({ rows: Array.from(this._rows.values()) });
    }
    updateRow(row) {
        const listeners = this._rowUpdateListeners.get(row.id);
        if (listeners) {
            listeners.forEach((listener) => listener());
        }
        this._tableUpdateListeners.forEach((listener) => listener());
    }
    updateRows() {
        this.setSnapshot({ rows: Array.from(this._rows.values()) });
    }
    clearRows() {
        this._rows.clear();
        this.setSnapshot({ rows: [] });
    }
    notifyRowsListeners() {
        this._rowUpdateListeners.forEach((listeners) => {
            listeners.forEach((listener) => listener());
        });
    }
    notifyTableListeners() {
        this._tableUpdateListeners.forEach((listener) => listener());
    }
}
